import { Channel, NotificationType } from "@swivl-mono/types";

import { ToastVariant } from "./ToastWrapper";

interface ToastClassNamesConfig {
  wrapper: string;
}

const toastVariantConfig: Record<string, Record<string, ToastClassNamesConfig>> = {
  [NotificationType.TOAST]: {
    default: {
      wrapper: "bg-white text-black border-grey-500"
    },
    error: {
      wrapper: "bg-red-500 text-white border-red-700"
    },
    success: {
      wrapper: "bg-green-500 text-white border-green-700"
    }
  },
  [NotificationType.ESCALATION]: {
    [Channel.SMS]: {
      wrapper: "bg-white text-black border-teal-500"
    },
    [Channel.WEB]: {
      wrapper: "text-black bg-white border-orange-500"
    },
    [Channel.VOICE]: {
      wrapper: "bg-black text-white"
    }
  }
};

export const getToastClassNamesConfig = (type: NotificationType, variant: Channel | ToastVariant): ToastClassNamesConfig => {
  const typeConfig = toastVariantConfig?.[type]?.[variant] || toastVariantConfig[NotificationType.TOAST]?.[ToastVariant.DEFAULT];
  if (!typeConfig) {
    throw new Error(`unknown notification type: ${type}`);
  }

  return typeConfig;
};
